import { Box, Fade, LinearProgress, alpha, styled } from "@mui/material"
import { useContext } from "react"

import { ColoursForTiles } from "@/constants/SidebarColours"
import SidebarContext from "@/contexts/data/SidebarContext"
import { LoadingContext } from "@/contexts/layouts/LoadingContext"
import { Outlet } from "react-router"
import SidebarTile from "../Tiles/SideBar/SidebarTile"
import Header from "./Header"
import HeaderMenuContext from "@/contexts/data/HeaderMenuContext"

type Props = {
    title?: string
    children?: React.ReactNode
}

const ContentZone = styled(Box)(({ theme }) => ({
    flex: '1 1 auto',
    display: 'flex',
    alignItems: 'stretch',
    backgroundColor: alpha(theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.common.black, 0),
    flexDirection: 'column',

    [`${theme.breakpoints.up('lg')}`]: {
        flexDirection: 'row'
    }  
}))

const LeftSideContentZone = styled(Box)(() => ({
    flex: '1 1 auto',
    overflow: 'hidden'
}))


const PageZone = styled(Box)(() => ({
    margin: '0px',
    padding: '0px',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column'

}))


const SideBar = styled(Box)(({ theme }) => ({
    flex: '0 0 auto',
    width: 'unset',
    position: 'relative',
    backgroundColor: theme.palette.mode === 'dark' ? alpha(theme.palette.common.white, 0.09) : theme.palette.common.white,
    borderLeft: undefined,
    borderLeftColor: undefined,
    borderTop: '1px solid',
    borderTopColor: alpha(theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.common.black, 0.12),
    boxShadow: theme.shadows[3],

    [`${theme.breakpoints.up('lg')}`]: {
        width: '220px',
        borderLeft: '1px solid',
        borderLeftColor: alpha(theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.common.black, 0.12),
        borderTop: undefined,
        borderTopColor: undefined,
    }  

}))

const SideBarBox = styled(Box)(({ theme }) => ({
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    //justifyContent: 'center',

    [`${theme.breakpoints.up('sm')}`]: {
        display: 'flex',
        flexDirection: 'row',
    },

    [`${theme.breakpoints.up('lg')}`]: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'nowrap',
    }  
}))

const LoadingBox = styled(Box)(({ }) => ({
    position: 'fixed',
    left: 0,
    right: 0,
    top: '64px',
    width: '100%',
    zIndex: 1000
}))
const Layout = ({}: Props) => {
    
    const { data: sidebar, loading: sidebarLoading} = useContext(SidebarContext);
    const { data: headerMenu} = useContext(HeaderMenuContext);
    const { loading, validating } = useContext(LoadingContext);
        
    // const [state, setState] = useState<{x: number, y: number}>({x: 0, y: 15})
    // const boxRef = useRef<HTMLDivElement>();



    // if (trials == undefined && !loading) {
    //     return (
    //         <BasicAlert
    //             severity="error"
    //             title={'403 Forbidden'}
    //             description={"User does not have the required permissions for any trials."}
    //             icon={faExclamationTriangle}
    //         />
    //     );
    // }

    return (
        <>
            <PageZone>
                
                <Header 
                    headerMenu={headerMenu}
                />

                {/* Body */}
                <ContentZone>
                { 
                    (loading || validating) && (
                        <LoadingBox>
                            <LinearProgress color="secondary" />
                        </LoadingBox>
                    ) 
                }
                
                    <LeftSideContentZone>
                        <Fade appear in={!loading}>
                            <div>
                                <Outlet />
                            </div>
                        </Fade>
                    </LeftSideContentZone>

                    {
                        (!sidebarLoading && !!sidebar && sidebar.length > 0) && (
                            
                            <SideBar>
                                    {/* Colours range from primary to secondary using this
                                    https://meyerweb.com/eric/tools/color-blend/#56287B:EC008C:4:hex
                                    */}
                                <SideBarBox>
                                    {
                                        sidebar.map((x, i) => {
                                            return (
                                                <SidebarTile
                                                    key={i}
                                                    name={x.name}
                                                    iconPrefix={x.iconPrefix}
                                                    iconName={x.iconName}
                                                    link={x.link}
                                                    LinkNewTab={x.linkNewTab}
                                                    color={!x.color ? ColoursForTiles[sidebar.length-1][i] : x.color}
                                                />
                                            );
                                        })
                                    }
                                </SideBarBox>
                            </SideBar>
                        )
                    }
                </ContentZone>
            </PageZone>
        </>
    )
}

export default Layout;